<template>
  <div class="container">
    <div class="head">
      <div class="title">
        <div class="text">游客投诉处置满意度</div>
        <div class="branch">-0.3</div>
      </div>
      <div class="tip">
        <div class="con">大理州-大理市</div>
        <div class="con">一类地区</div>
      </div>
      <div class="date">2019-11-01 12:31:22</div>
    </div>
    <div class="pg-pd12">
      <causeDeduction :causeContent="causeContent" />

      <div class="main">
        <div class="title">投诉办结情况</div>
        <div class="content">
          <div class="tongji">
            <div class="tj-item">
              <div class="name">满意</div>
              <div class="num">78<span>起</span></div>
            </div>
            <div class="tj-item">
              <div class="name">基本满意</div>
              <div class="num">22<span>起</span></div>
            </div>
            <div class="tj-item">
              <div class="name">总数</div>
              <div class="num">100<span>起</span></div>
            </div>
          </div>
          <div class="ts-list" @click="navTo()">
            <span> 查看投诉件列表</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
    import causeDeduction from './components/causeDeduction'; // 扣分原因
    import api from '../../service/modules/appraise';

    export default {
        components: {
            causeDeduction
        },

        data () {
            return {
                causeContent: '扣分=20-（满意件数量x20+基本满意件数量x12）÷投诉件总量'

            }
        },
        methods: {
            // 考核明细接口
            getSubAssessDetail () {
                api.getAssessDetailById({ id: '335C6B06-33CA-D7E4-B539-C35B6B9BA99E', complainId: '201907141721243498431', subType: 'A1' }).then(res => {
                    if (res.ret === 0) {
                        this.assessDetail = res.data.assessDetail
                        this.causeContent = res.data.assessDetail.deductionReason// 扣分原因
                        this.complainRateInfo = res.data.assessDetail.complainRateInfo
                    } else {
                        this.$Message.error(res.data.msg)
                    }
                });
            },
            navTo () {
                this.$router.push({
                    path: '/appraise/complainList'
                })
            }
        },

        mounted () {},

        created () {
            this.getSubAssessDetail()
        }

    }
</script>
<style scoped lang="less">
  .container {
    min-height: 100vh;
    background: rgba(251, 251, 251, 1);
    padding-bottom: 24px;

    .pg-pd12 {
      padding-left: 12px;
      padding-right: 12px;

    }

    .head {
      width: 100%;
      background: #fff;
      padding: 24px 12px;
      margin-bottom: 24px;

      .title {
        height: 22px;
        line-height: 22px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .text {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
        }

        .branch {
          height: 22px;
          font-size: 22px;
          font-family: DIN-Medium, DIN;
          font-weight: 500;
          color: rgba(255, 77, 77, 1);
          line-height: 22px;
        }
      }

      .tip {
        margin-top: 12px;
        display: flex;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(54, 179, 116, 1);

        .con {
          border: 1Px solid rgba(54, 179, 116, 1);
          padding: 2px 4px;
          margin-right: 14px;
        }
      }

      .date {
        margin-top: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 12px;
      }
    }

    .main {
      margin: 24px 0 30px 0;

      .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }

      .content {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        margin-top: 12px;

        .tongji {
          display: flex;
          align-items: center;
          border-top: solid 1Px #EEEEEE;
          border-bottom: solid 1Px #EEEEEE;
          margin-top: 24px;
          .tj-item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            flex: 1;
            height: 72px;
            text-align: center;
            border-right: solid 1Px #EEEEEE;

            .name {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
            }

            .num {
              font-size: 20px;
              font-family: DIN-Bold, DIN;
              font-weight: bold;
              color: rgba(54, 179, 116, 1);
              margin-top: 8px;

              span {
                font-size: 10px;
                padding-left: 4px;
              }
            }
          }

          .tj-item:last-child {
            border-right: 0;
          }
        }

        .ts-list {
          padding: 12px 0;
          text-align: center;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(155, 155, 155, 1);
          line-height: 17px;

          span {
            padding-right: 10px;
            background: url(../../assets/image/t-right.png) no-repeat;
            background-size: 8px 8px;
            background-position: right center;
          }
        }
      }
    }

    .complain {
      position: relative;
      line-height: 46px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 3px;
      padding: 0 16px;
      margin-top: 24px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }

    .complain::after {
      content: '';
      position: absolute;
      right: 16px;
      top: 16px;
      width: 12px;
      height: 12px;
      background: url(../../assets/image/t-right.png) no-repeat;
      background-size: 12px 12px;
    }
  }
</style>
